import Type from './Type';
export function isIScrollable(node) {
    return node.type === Type.Scrollable;
}
export default isIScrollable;    //# sourceMappingURL=isIScrollable.js.map
